import updateCart from './update-popup-cart.js';
import { applyPromoFromBanner } from './helpers';
import { postData } from './fetch';

import './promo-logic';

window.addEventListener('load', () => {
  const addPromoProductBtn = document.querySelector('.add-promo-product');
  const addSetProductBtn = document.querySelector('.add-set-product');
  const popupWrapper = document.querySelector('.sale-popup-wrapper');
  const setPopupWrapper = document.querySelector('.set-popup-wrapper');
  const applyPromoBtn = document.querySelector('.apply-promo');

  if (addPromoProductBtn) {
    addPromoProductBtn.addEventListener('click', async () => {
      const { id } = addPromoProductBtn.dataset;

      const body = {
        id,
        quantity: 1,
      };

      addPromoProductBtn.textContent = 'Загрузка...';
      addPromoProductBtn.classList.add('disabled');

      const response = await postData('/cart', body);

      if (response) {
        if (response.statusCode === 200) {
          addPromoProductBtn.classList.remove('disabled');
          addPromoProductBtn.classList.add('added');
          addPromoProductBtn.textContent = 'Добавлено';

          if (popupWrapper) {
            setTimeout(() => {
              popupWrapper.classList.remove('active');
              addPromoProductBtn.classList.remove('added');
              addPromoProductBtn.textContent = 'Добавить в корзину';
            }, 2000);
          }
          updateCart(response.data, response.data.additional);
        } else {
          addPromoProductBtn.textContent = 'Добавить в корзину';
        }
      }
    });
  }

  if (addSetProductBtn) {
    addSetProductBtn.addEventListener('click', () => {
      if (popupWrapper) {
        popupWrapper.classList.remove('active');
      }

      if (setPopupWrapper) {
        setPopupWrapper.classList.add('active');
      }
    });
  }

  if (applyPromoBtn) {
    applyPromoBtn.addEventListener('click', () => {
      const { number } = applyPromoBtn.dataset;

      const body = {
        promo: number,
        hidden: true,
      };

      applyPromoBtn.textContent = 'Загрузка...';
      applyPromoBtn.classList.add('disabled');

      applyPromoFromBanner(body, applyPromoBtn);
    });
  }
});
